import type { Brand } from "../lib/ChatbotConfig";

// The brand is part of ChatbotConfig and therefore known for every embedding —
// it is the authoritative source here. Deriving the link from the host page's
// URL instead would silently fall back to the wrong brand on every domain that
// is not one of the four production domains (staging, previews, landing pages).
const dataProtectionUrls: Record<Brand, string> = {
  training: "https://www.wbstraining.de/datenschutz/",
  group: "https://www.wbs-gruppe.de/datenschutz/",
  schools: "https://www.wbs-schulen.de/datenschutz/",
  academy: "https://www.wbsakademie.de/datenschutz/",
};

export const getDataprotectionLink = (brand: Brand): string =>
  // Host pages embed the standalone bundle from plain JS, where TypeScript
  // cannot enforce the config — mirror the `training` fallback the theme and
  // the deployment ID use, so all three stay consistent.
  dataProtectionUrls[brand] ?? dataProtectionUrls.training;
